module.exports = __webpack_public_path__ + "img/metaImage.7d3808f5.png";